import type { Game, Category, Article } from '@/types';

export const categories: Category[] = [
  {
    id: 'cat-1',
    name: '日系成人游戏',
    slug: 'japanese',
    icon: 'ri-earth-line',
    description: '经典日系成人游戏精选，涵盖视觉小说、RPG、SLG等多种类型，体验纯正日式风格',
  },
  {
    id: 'cat-2',
    name: '欧美成人游戏',
    slug: 'western',
    icon: 'ri-global-line',
    description: '欧美精品成人游戏合集，高品质3D画面，丰富的剧情设计和沉浸式体验',
  },
  {
    id: 'cat-3',
    name: 'PC成人游戏',
    slug: 'pc',
    icon: 'ri-computer-line',
    description: 'PC平台专属成人游戏，支持Windows系统，高画质流畅运行，兼容性强',
  },
  {
    id: 'cat-4',
    name: '安卓成人游戏',
    slug: 'android',
    icon: 'ri-android-line',
    description: '安卓手机成人游戏下载专区，随时随地畅玩，优化触屏操作体验',
  },
  {
    id: 'cat-5',
    name: '汉化成人游戏',
    slug: 'chinese-patched',
    icon: 'ri-translate-2',
    description: '高品质汉化成人游戏资源，专业翻译团队精心汉化，无障碍畅玩海外佳作',
  },
  {
    id: 'cat-6',
    name: 'SLG策略游戏',
    slug: 'slg',
    icon: 'ri-shapes-line',
    description: '策略类成人游戏精选，培养、经营、战斗一应俱全，深度策略玩法',
  },
  {
    id: 'cat-7',
    name: 'RPG角色扮演',
    slug: 'rpg',
    icon: 'ri-sword-line',
    description: '角色扮演类成人游戏，丰富剧情、自由探索、角色养成，沉浸式冒险体验',
  },
  {
    id: 'cat-8',
    name: '视觉小说',
    slug: 'visual-novel',
    icon: 'ri-book-open-line',
    description: '视觉小说类成人游戏，精美的立绘与CG，丰富的分支剧情和多结局设计',
  },
];

export const games: Game[] = [
  {
    id: 'game-1',
    title: '堕落公主与勇者',
    slug: 'fallen-princess',
    category: 'rpg',
    categoryName: 'RPG角色扮演',
    image: 'https://readdy.ai/api/search-image?query=Dark%20fantasy%20RPG%20game%20cover%20art%2C%20mysterious%20female%20character%20in%20gothic%20armor%2C%20dark%20castle%20background%2C%20dramatic%20lighting%2C%20anime%20art%20style%2C%20rich%20crimson%20and%20black%20color%20palette%2C%20detailed%20illustration%2C%20professional%20game%20cover%20design&width=600&height=800&seq=game-fallen-princess&orientation=portrait',
    rating: 4.8,
    platform: ['PC', '安卓'],
    description: '经典日系RPG成人游戏，讲述堕落公主与勇者之间的禁忌冒险故事，丰富的剧情分支和多结局设定',
    downloads: 158000,
    releaseDate: '2025-12-15',
    developer: '樱花工作室',
    tags: ['RPG', '日系', '剧情丰富', '多结局'],
  },
  {
    id: 'game-2',
    title: '欲望都市：夜生活',
    slug: 'desire-city',
    category: 'western',
    categoryName: '欧美成人游戏',
    image: 'https://readdy.ai/api/search-image?query=Modern%20urban%20nightlife%20game%20cover%2C%20stylish%20character%20in%20city%20lights%2C%20neon%20lit%20skyline%20background%2C%20western%203D%20art%20style%2C%20dark%20sophisticated%20atmosphere%2C%20deep%20purple%20and%20gold%20accents%2C%20professional%20game%20cover%20design&width=600&height=800&seq=game-desire-city&orientation=portrait',
    rating: 4.6,
    platform: ['PC'],
    description: '欧美高人气成人SLG游戏，体验都市夜生活的诱惑与冒险，超高品质3D画面和自由度极高的玩法',
    downloads: 235000,
    releaseDate: '2026-01-20',
    developer: 'Midnight Studio',
    tags: ['SLG', '欧美', '3D', '高自由度'],
  },
  {
    id: 'game-3',
    title: '樱花恋歌',
    slug: 'sakura-love-song',
    category: 'visual-novel',
    categoryName: '视觉小说',
    image: 'https://readdy.ai/api/search-image?query=Romantic%20visual%20novel%20game%20cover%2C%20beautiful%20anime%20girl%20under%20cherry%20blossom%20trees%2C%20soft%20pink%20petals%20falling%2C%20Japanese%20school%20setting%2C%20warm%20spring%20lighting%2C%20delicate%20romantic%20atmosphere%2C%20anime%20art%20style&width=600&height=800&seq=game-sakura-love&orientation=portrait',
    rating: 4.9,
    platform: ['PC', '安卓'],
    description: '唯美日系视觉小说，在樱花纷飞的季节里，体验三段刻骨铭心的恋爱故事，全语音豪华阵容',
    downloads: 198000,
    releaseDate: '2026-03-08',
    developer: '樱花工作室',
    tags: ['视觉小说', '日系', '恋爱', '全语音'],
  },
  {
    id: 'game-4',
    title: '黑暗地牢：禁忌之章',
    slug: 'dark-dungeon-forbidden',
    category: 'slg',
    categoryName: 'SLG策略游戏',
    image: 'https://readdy.ai/api/search-image?query=Dark%20dungeon%20crawler%20game%20cover%2C%20gothic%20warrior%20in%20shadowy%20underground%20temple%2C%20torch%20light%20illuminating%20ancient%20ruins%2C%20dark%20fantasy%20art%2C%20mysterious%20and%20foreboding%20atmosphere%2C%20detailed%20illustration%20with%20warm%20torch%20glow&width=600&height=800&seq=game-dark-dungeon&orientation=portrait',
    rating: 4.7,
    platform: ['PC'],
    description: '暗黑风格地牢探索SLG，招募各具特色的角色，深入禁忌地牢，揭开被封印的古老秘密',
    downloads: 124000,
    releaseDate: '2025-11-30',
    developer: '深渊制作组',
    tags: ['SLG', '暗黑', '地牢', '策略'],
  },
  {
    id: 'game-5',
    title: '魅魔契约',
    slug: 'succubus-contract',
    category: 'japanese',
    categoryName: '日系成人游戏',
    image: 'https://readdy.ai/api/search-image?query=Fantasy%20game%20cover%20featuring%20mysterious%20supernatural%20character%20with%20wings%2C%20magical%20dark%20aesthetic%2C%20elegant%20gothic%20style%2C%20moonlit%20castle%20background%2C%20rich%20jewel%20tones%2C%20anime%20fantasy%20art%2C%20professional%20game%20illustration&width=600&height=800&seq=game-succubus&orientation=portrait',
    rating: 4.5,
    platform: ['PC', '安卓'],
    description: '与魅魔签订契约，开启一段充满诱惑与危险的冒险之旅。日系精美画风，全动态CG演出',
    downloads: 167000,
    releaseDate: '2026-02-14',
    developer: '月下工作室',
    tags: ['日系', '幻想', '动态CG', '冒险'],
  },
  {
    id: 'game-6',
    title: '狂野西部：亡命之徒',
    slug: 'wild-west-outlaw',
    category: 'western',
    categoryName: '欧美成人游戏',
    image: 'https://readdy.ai/api/search-image?query=Western%20themed%20game%20cover%2C%20rugged%20outlaw%20character%20in%20desert%20landscape%2C%20dramatic%20sunset%20sky%2C%20dusty%20frontier%20town%20background%2C%20cinematic%20western%20style%2C%20warm%20golden%20hour%20lighting%2C%20professional%20game%20cover&width=600&height=800&seq=game-wild-west&orientation=portrait',
    rating: 4.4,
    platform: ['PC'],
    description: '西部题材成人开放世界游戏，在蛮荒西部建立你的王国，体验亡命之徒的自由与浪漫',
    downloads: 89000,
    releaseDate: '2026-04-01',
    developer: 'Frontier Games',
    tags: ['欧美', '开放世界', '西部', '冒险'],
  },
  {
    id: 'game-7',
    title: '学园默示录',
    slug: 'campus-apocalypse',
    category: 'chinese-patched',
    categoryName: '汉化成人游戏',
    image: 'https://readdy.ai/api/search-image?query=Japanese%20school%20setting%20game%20cover%2C%20students%20in%20uniforms%20in%20dramatic%20scene%2C%20school%20building%20at%20twilight%2C%20anime%20art%20style%2C%20mysterious%20and%20tense%20atmosphere%2C%20warm%20evening%20light%2C%20detailed%20character%20illustration&width=600&height=800&seq=game-campus-apoc&orientation=portrait',
    rating: 4.8,
    platform: ['PC', '安卓'],
    description: '超高人气日系校园题材，专业汉化组精心汉化。末日背景下校园中的生存与情感交织',
    downloads: 312000,
    releaseDate: '2025-10-20',
    developer: '东京游戏社',
    tags: ['汉化', '日系', '校园', '生存'],
  },
  {
    id: 'game-8',
    title: '精灵之森的秘密',
    slug: 'elf-forest-secret',
    category: 'android',
    categoryName: '安卓成人游戏',
    image: 'https://readdy.ai/api/search-image?query=Fantasy%20forest%20game%20cover%2C%20beautiful%20elf%20character%20in%20enchanted%20woodland%2C%20magical%20glowing%20particles%2C%20ancient%20trees%20and%20mushrooms%2C%20ethereal%20lighting%2C%20anime%20fantasy%20art%20style%2C%20mysterious%20and%20enchanting%20atmosphere&width=600&height=800&seq=game-elf-forest&orientation=portrait',
    rating: 4.6,
    platform: ['安卓'],
    description: '专为安卓优化的精灵题材RPG，触屏操作流畅自如，探索神秘精灵之森的奇幻秘密',
    downloads: 201000,
    releaseDate: '2026-05-15',
    developer: '森林制作组',
    tags: ['安卓', 'RPG', '精灵', '触屏优化'],
  },
  {
    id: 'game-9',
    title: '帝国风云',
    slug: 'empire-storm',
    category: 'slg',
    categoryName: 'SLG策略游戏',
    image: 'https://readdy.ai/api/search-image?query=Strategic%20empire%20building%20game%20cover%2C%20powerful%20ruler%20on%20throne%2C%20grand%20palace%20interior%2C%20dramatic%20lighting%20from%20stained%20glass%20windows%2C%20medieval%20fantasy%20style%2C%20rich%20gold%20and%20deep%20red%20colors%2C%20professional%20illustration&width=600&height=800&seq=game-empire-storm&orientation=portrait',
    rating: 4.3,
    platform: ['PC'],
    description: '帝国经营SLG大作，从零开始建立你的帝国，管理资源、发展军队、征服邻国，书写属于你的传奇',
    downloads: 76000,
    releaseDate: '2026-06-01',
    developer: '帝国游戏',
    tags: ['SLG', '经营', '战争', '策略'],
  },
  {
    id: 'game-10',
    title: '星海迷航',
    slug: 'star-ocean-voyage',
    category: 'chinese-patched',
    categoryName: '汉化成人游戏',
    image: 'https://readdy.ai/api/search-image?query=Sci-fi%20space%20adventure%20game%20cover%2C%20futuristic%20character%20in%20spacesuit%2C%20distant%20galaxy%20and%20nebula%20background%2C%20starship%20bridge%20setting%2C%20anime%20sci-fi%20art%20style%2C%20deep%20space%20blues%20and%20cosmic%20purples%2C%20cinematic%20lighting&width=600&height=800&seq=game-star-ocean&orientation=portrait',
    rating: 4.7,
    platform: ['PC', '安卓'],
    description: '科幻题材太空冒险，完整汉化版。在浩瀚星海中探索未知星球，邂逅各色外星文明',
    downloads: 143000,
    releaseDate: '2026-02-28',
    developer: '银河制作组',
    tags: ['汉化', '科幻', '太空', '冒险'],
  },
  {
    id: 'game-11',
    title: '女仆咖啡厅物语',
    slug: 'maid-cafe-story',
    category: 'japanese',
    categoryName: '日系成人游戏',
    image: 'https://readdy.ai/api/search-image?query=Cozy%20maid%20cafe%20game%20cover%2C%20cute%20anime%20character%20in%20maid%20uniform%2C%20warm%20cafe%20interior%20background%2C%20soft%20lighting%20from%20windows%2C%20Japanese%20slice%20of%20life%20style%2C%20pastel%20and%20warm%20tone%20illustration%2C%20detailed%20character%20design&width=600&height=800&seq=game-maid-cafe&orientation=portrait',
    rating: 4.9,
    platform: ['PC', '安卓'],
    description: '治愈系女仆咖啡厅经营模拟，招募可爱的女仆，打造最受欢迎的咖啡厅，全语音豪华版',
    downloads: 289000,
    releaseDate: '2025-09-10',
    developer: '樱花工作室',
    tags: ['日系', '经营', '治愈', '全语音'],
  },
  {
    id: 'game-12',
    title: '深渊觉醒',
    slug: 'abyss-awakening',
    category: 'pc',
    categoryName: 'PC成人游戏',
    image: 'https://readdy.ai/api/search-image?query=Dark%20fantasy%20action%20game%20cover%2C%20armored%20warrior%20facing%20giant%20monster%2C%20hellish%20abyss%20background%20with%20lava%20glow%2C%20epic%20cinematic%20style%2C%20intense%20dramatic%20lighting%2C%20dark%20red%20and%20black%20color%20scheme%2C%20professional%20illustration&width=600&height=800&seq=game-abyss-awake&orientation=portrait',
    rating: 4.5,
    platform: ['PC'],
    description: 'PC独占硬核动作RPG，虚幻引擎5打造极致画面，深渊中觉醒的力量将改变一切',
    downloads: 98000,
    releaseDate: '2026-07-01',
    developer: '深渊制作组',
    tags: ['PC', '动作', 'RPG', '虚幻5'],
  },
];

export const articles: Article[] = [
  {
    id: 'article-1',
    title: '2026年最值得期待的十款日系成人游戏',
    slug: 'top-10-japanese-games-2026',
    excerpt: '新的一年，日系成人游戏市场迎来了众多令人期待的大作。我们精选了十款最值得关注的游戏，从RPG到视觉小说，总有一款适合你。',
    content: `<p>2026年对于日系成人游戏爱好者来说，注定是不平凡的一年。多家知名厂商纷纷公布了年度大作计划，让我们一起来盘点那些最值得期待的作品。</p>
<h3>1. 《樱花恋歌》- 视觉小说的巅峰之作</h3>
<p>由樱花工作室倾力打造的《樱花恋歌》，以其精美的CG和感人至深的剧情赢得了广泛好评。游戏采用全语音阵容，三位女主角的故事线各自独立又相互交织，给玩家带来沉浸式的恋爱体验。</p>
<h3>2. 《魅魔契约》- 幻想RPG新标杆</h3>
<p>月下工作室的最新力作，将日系RPG的经典元素与现代游戏设计理念完美融合。动态CG演出系统让每一场战斗都充满视觉冲击力。</p>
<h3>3. 《学园默示录》- 校园题材的创新之作</h3>
<p>东京游戏社推出的这款校园生存题材游戏，在传统校园恋爱的基础上加入了末日生存元素，紧张刺激的剧情让人欲罢不能。</p>
<h3>游戏选择建议</h3>
<p>选择成人游戏时，建议根据自己的喜好和硬件配置来挑选。PC玩家可以优先考虑画面表现力更强的大作，而安卓用户则可以选择经过触屏优化的专属版本。</p>
<p>无论你是RPG爱好者、SLG策略玩家，还是视觉小说的忠实粉丝，2026年的日系成人游戏市场都能满足你的需求。记得关注我们的最新评测，获取第一手游戏资讯。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Japanese%20anime%20style%20gaming%20collage%2C%20multiple%20colorful%20game%20character%20artworks%2C%20bright%20and%20vibrant%20composition%2C%20gaming%20magazine%20feature%20style%2C%20dynamic%20layout%20with%20text%20space&width=1200&height=600&seq=article-japanese-2026&orientation=landscape',
    category: '游戏资讯',
    author: '游戏观察员',
    publishDate: '2026-08-01',
    readTime: 8,
    tags: ['日系游戏', '2026新作', '游戏推荐'],
  },
  {
    id: 'article-2',
    title: '成人游戏汉化质量如何判断？资深玩家教你避坑',
    slug: 'how-to-judge-translation-quality',
    excerpt: '汉化质量直接影响游戏体验。本文从翻译准确性、UI适配、文本完整度等角度，教你如何快速判断一款成人游戏的汉化水平。',
    content: `<p>对于不懂日语的玩家来说，汉化补丁是体验海外成人游戏的重要桥梁。但市面上的汉化质量参差不齐，如何快速判断汉化水平？本文将为你详细解答。</p>
<h3>翻译准确性是第一标准</h3>
<p>优质的汉化首先体现在翻译的准确性上。好的汉化团队不仅精通日语，更了解游戏的文化背景，能够准确传达原文的意思和情感。而劣质汉化往往充斥着机器翻译的痕迹，语句生硬不通顺。</p>
<h3>UI适配不容忽视</h3>
<p>很多玩家只关注文本翻译，却忽略了UI适配的重要性。专业汉化团队会对游戏的界面、按钮、菜单进行完整的中文化处理，确保玩家操作流畅。如果发现游戏中有大量未翻译的英文或日文UI元素，说明汉化不完整。</p>
<h3>文本完整度检查</h3>
<p>部分汉化版本存在漏翻现象，特别是在支线剧情、道具描述等次要文本中。建议在游戏初期多留意各种文本的翻译情况，及时发现汉化完整度的问题。</p>
<h3>推荐汉化质量过硬的游戏</h3>
<p>在我们的平台上，所有汉化游戏都经过严格筛选，确保翻译质量和UI适配达到专业水准。《学园默示录》、《星海迷航》等作品的汉化版本得到了玩家的一致好评。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Game%20localization%20and%20translation%20concept%20art%2C%20Japanese%20and%20Chinese%20text%20side%20by%20side%2C%20gaming%20UI%20interface%20with%20subtitles%2C%20professional%20translation%20work%20setting%2C%20clean%20modern%20design%2C%20warm%20lighting&width=1200&height=600&seq=article-translation&orientation=landscape',
    category: '游戏攻略',
    author: '汉化观察室',
    publishDate: '2026-07-25',
    readTime: 6,
    tags: ['汉化', '游戏攻略', '避坑指南'],
  },
  {
    id: 'article-3',
    title: '安卓成人游戏安装指南：从下载到畅玩全流程',
    slug: 'android-game-install-guide',
    excerpt: '很多玩家在安卓设备上安装成人游戏时会遇到各种问题。这篇指南将手把手教你从下载到安装再到优化的完整流程。',
    content: `<p>安卓平台上的成人游戏种类繁多，但安装过程对于一些新手玩家来说可能有些复杂。不用担心，这份指南将带你走完全流程。</p>
<h3>第一步：选择安全可靠的下载渠道</h3>
<p>安全永远是第一位的。建议从黄游下载官方平台获取游戏文件，我们所有资源都经过安全检测，确保无毒无害。</p>
<h3>第二步：允许安装未知来源应用</h3>
<p>由于大多数成人游戏不在官方应用商店上架，你需要在手机设置中开启"允许安装未知来源应用"选项。路径一般为：设置 → 安全 → 未知来源。</p>
<h3>第三步：文件解压与安装</h3>
<p>下载完成后，使用文件管理器找到下载的APK或压缩包。如果是压缩包格式，需要先解压再安装APK文件。部分大型游戏还需要将数据包放置到指定目录。</p>
<h3>第四步：权限设置与优化</h3>
<p>首次运行游戏时，请根据提示授予必要的存储和网络权限。为了获得更好的游戏体验，建议关闭后台应用，释放内存空间。</p>
<h3>常见问题解决</h3>
<p>如果遇到闪退、黑屏等问题，可以尝试清除游戏缓存或重新安装。大部分兼容性问题都可以通过更新手机系统或游戏版本来解决。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Android%20smartphone%20with%20game%20installation%20screen%2C%20modern%20mobile%20device%20on%20desk%2C%20gaming%20setup%20with%20headphones%2C%20clean%20tech%20lifestyle%20photography%2C%20warm%20ambient%20lighting%2C%20professional%20product%20shot&width=1200&height=600&seq=article-android-guide&orientation=landscape',
    category: '游戏攻略',
    author: '技术指南组',
    publishDate: '2026-07-20',
    readTime: 10,
    tags: ['安卓', '安装教程', '新手攻略'],
  },
  {
    id: 'article-4',
    title: 'SLG成人游戏入门推荐：策略与激情的完美结合',
    slug: 'slg-games-beginners-guide',
    excerpt: 'SLG策略类成人游戏以其深度的玩法和丰富的剧情深受玩家喜爱。本文为新手玩家推荐五款入门级SLG佳作。',
    content: `<p>SLG（Simulation Game）策略类成人游戏是近年来最受欢迎的类型之一。它将策略经营的深度玩法与成人内容巧妙结合，给玩家带来独特的游戏体验。</p>
<h3>为什么选择SLG游戏？</h3>
<p>SLG游戏的核心魅力在于"掌控感"。你不仅是故事的旁观者，更是整个游戏世界的建设者和决策者。从资源管理到角色培养，每一步都需要精心策划。</p>
<h3>入门推荐：《欲望都市：夜生活》</h3>
<p>这款游戏以其直观的操作界面和循序渐进的教学系统，成为SLG新手的最佳入门选择。3D画面精美，剧情节奏恰到好处，不会让新手感到无从下手。</p>
<h3>进阶之选：《帝国风云》</h3>
<p>当你熟悉了SLG的基本玩法后，《帝国风云》将为你打开更广阔的策略世界。宏大的世界观、复杂的经营系统和丰富的剧情线，让每次游戏都有新鲜感。</p>
<h3>硬核挑战：《黑暗地牢：禁忌之章》</h3>
<p>对于喜欢高难度挑战的玩家，《黑暗地牢》是不容错过的作品。严苛的资源限制和高风险决策让每一局都充满紧张感。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Strategy%20game%20interface%20with%20map%20and%20resources%2C%20fantasy%20kingdom%20management%20theme%2C%2C%20warm%20golden%20and%20dark%20gothic%20color%20palette%2C%20epic%20game%20art%20style&width=1200&height=600&seq=article-slg-guide&orientation=landscape',
    category: '游戏攻略',
    author: '策略大师',
    publishDate: '2026-07-15',
    readTime: 7,
    tags: ['SLG', '策略游戏', '新手推荐'],
  },
  {
    id: 'article-5',
    title: '视觉小说推荐：五款让人泪目的剧情神作',
    slug: 'top-visual-novels-tear-jerker',
    excerpt: '优秀的视觉小说能够触动人心最柔软的部分。我们精选了五款剧情出色的成人向视觉小说，每一部都值得你细细品味。',
    content: `<p>视觉小说是成人游戏中最具文学性的类型。优秀的视觉小说不仅有精美的画面，更有着媲美经典文学作品的剧情深度。</p>
<h3>《樱花恋歌》- 春天的约定</h3>
<p>作为2026年最受好评的视觉小说，《樱花恋歌》用三段交织的恋爱故事，讲述了关于成长、选择和遗憾的永恒主题。全语音演出让角色的情感表达更加细腻动人。</p>
<h3>视觉小说的独特魅力</h3>
<p>与其他类型不同，视觉小说更注重文字的力量。精美的CG和恰当的背景音乐只是锦上添花，真正的核心是那些能让你停下来思考的文字。</p>
<h3>如何获得最佳阅读体验</h3>
<p>建议在安静的环境下，使用耳机体验视觉小说。关闭手机通知，给自己一个完整的沉浸式阅读时间。很多玩家表示，在深夜独自游玩时更能感受到剧情的冲击力。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Emotional%20visual%20novel%20scene%2C%20anime%20characters%20in%20dramatic%20moment%2C%20soft%20lighting%20through%20window%2C%20tearful%20farewell%20atmosphere%2C%20Japanese%20anime%20art%20style%2C%20warm%20emotional%20tone%2C%20cinematic%20composition&width=1200&height=600&seq=article-visual-novel&orientation=landscape',
    category: '游戏评测',
    author: '文学游戏迷',
    publishDate: '2026-07-10',
    readTime: 9,
    tags: ['视觉小说', '催泪', '剧情神作'],
  },
  {
    id: 'article-6',
    title: 'PC vs 安卓：成人游戏平台选择全攻略',
    slug: 'pc-vs-android-platform-guide',
    excerpt: 'PC和安卓各有优势，如何根据自己的需求选择合适的游戏平台？我们从画面、便携性、游戏库等维度进行全面对比。',
    content: `<p>面对琳琅满目的成人游戏，选择合适的平台是玩家面临的第一道选择题。PC和安卓各有千秋，本文将为你详细分析。</p>
<h3>PC平台优势</h3>
<p>PC平台最大的优势在于性能。强大的硬件支持让游戏能够呈现最精美的画面效果，特别是在3D游戏和大规模SLG中优势明显。此外，PC平台的游戏库更加丰富，大作品质更有保证。</p>
<h3>安卓平台优势</h3>
<p>安卓平台的核心竞争力在于便携性。你可以随时随地打开手机开始游戏，不受时间和地点的限制。经过触屏优化的游戏操作更加直观，适合碎片化时间游玩。</p>
<h3>我们的建议</h3>
<p>如果你追求极致画质和深度游戏体验，PC是不二之选。如果你更看重便捷性和随时随地游玩的自由，安卓平台更适合你。当然，很多游戏同时支持双平台，你可以在PC上体验主线剧情，在手机上完成日常任务。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=PC%20gaming%20setup%20next%20to%20android%20smartphone%2C%20dual%20device%20gaming%20comparison%2C%20modern%20desk%20setup%2C%20clean%20minimalist%20tech%20photography%2C%20warm%20ambient%20lighting%2C%20professional%20product%20comparison%20shot&width=1200&height=600&seq=article-pc-vs-android&orientation=landscape',
    category: '游戏攻略',
    author: '双平台玩家',
    publishDate: '2026-07-05',
    readTime: 8,
    tags: ['PC', '安卓', '平台对比'],
  },
];

export const siteConfig = {
  name: '黄游下载',
  tagline: '正版成人游戏安全下载平台',
  description: '黄游下载专属频道，提供海量成人游戏安全下载服务。严格筛选正版资源，支持多平台兼容，快速下载无广告骚扰。',
  keywords: '黄游下载,成人游戏下载,18+游戏下载,黄油游戏下载,PC成人游戏,安卓成人游戏下载,日系成人游戏',
  url: 'https://huangyouxiazai.com',
  email: 'contact@huangyouxiazai.com',
  phone: '400-888-6666',
  address: '广东省深圳市南山区科技园南路88号',
  foundingYear: 2018,
  stats: {
    totalGames: 1280,
    totalDownloads: 52800000,
    activeUsers: 860000,
    satisfaction: 98.5,
  },
};